import React from "react";
import { useCurrentOrganization } from "web/hooks/useCurrentOrganization"
import { useCurrentUser } from "web/hooks/useCurrentUser";

const CallToSubscribeBanner = () => {
    const {currentOrganization} = useCurrentOrganization();
    const user = useCurrentUser();

    // Check if force subscription end date is within next 2 weeks
    // const forceEndDate = currentOrganization?.nxVetForceSubscriptionEndDate ? new Date(currentOrganization.nxVetForceSubscriptionEndDate) : null;
    // const now = new Date();
    // const twoWeeksFromNow = new Date(now);
    // twoWeeksFromNow.setDate(now.getDate() + 14);
    

    // Only show banner if the date is valid and within the next 2 weeks
    // const isForceEndingSoon = forceEndDate && 
    //     !isNaN(forceEndDate.getTime()) &&
    //     forceEndDate.getFullYear() < 9999 && // Check year first
    //     forceEndDate.getTime() > now.getTime() && 
    //     forceEndDate.getTime() <= twoWeeksFromNow.getTime();

    // Check if force subscription end date exists
    const forceEndDateExists = Boolean(currentOrganization?.nxVetForceSubscriptionEndDate);

    // Return null for admin, active subscription, or handled by other, unless forceEndDate exists
    if (user.isAdmin || 
        currentOrganization?.nxVetSubscriptionStatus === "Active" || 
        currentOrganization?.nxVetSubscriptionStatus === "HandledByOther") {
        if (!forceEndDateExists) {
            return null; // Only return null if forceEndDate does not exist
        }
    }

    const isOwner = currentOrganization?.owners.find(o => o.id === user.id);
    const isExpired = currentOrganization?.nxVetSubscriptionStatus === "Expired";

    if (isExpired) {
        if (!isOwner) {
            return (
                <div className="w-full bg-gray-900 text-white p-2 text-center text-sm">
                    Your subscription has expired. Contact your organization owner to renew it.
                </div>
            );
        } else {
            return (
                <div className="w-full bg-gray-900 text-white p-2 text-center text-sm">
                    Your subscription has expired. See our current plans. <wbr /><a className="button primary !py-0 !px-2 mx-2" href="https://nx.vet/collections/frontpage" target="_blank" rel="noopener noreferrer">See plans &amp; pricing</a>
                </div>
            );
        }
    }

    if (!isOwner) {
        return (
            <div className="w-full bg-gray-900 text-white p-2 text-center text-sm">
                Your free trial is expiring soon. Contact your organization owner to subscribe to a plan.
            </div>
        );
    } else {
        return (
            <div className="w-full bg-gray-900 text-white p-2 text-center text-sm">
                Your free trial is expiring soon. <wbr />Upgrade to keep your features. <wbr /><a className="button primary !py-0 !px-2 mx-2" href="https://nx.vet/collections/frontpage" target="_blank" rel="noopener noreferrer">See plans &amp; pricing</a>
            </div>
        );
    }
};

export default CallToSubscribeBanner;
